<template>
  <div class="form__group">
    <div class="form__text">
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
name: "auth-text"
}
</script>

<style scoped>

</style>
